module.exports = __webpack_public_path__ + "static/scale-model-of-hallidie-building-in-berkeley-california-069812f303ff98db9b13acf43a40815f.png";